// src/services/apiService.js

const COMPANY_TYPES = {
  LISTED: 'Listed',
  UNLISTED: 'Unlisted'
};

const formatCurrency = (value) => {
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

const apiService = {
  // Patent endpoints
  getPatentValuation: async (patentNumber) => {
    const response = await fetch(`/api/patent/search/${patentNumber}`);
    if (!response.ok) {
      throw new Error('Patent not found');
    }
    return response.json();
  },
  
  getPatentsList: async () => {
    const response = await fetch('/api/patents');
    if (!response.ok) {
      throw new Error('Failed to fetch patents list');
    }
    return response.json();
  },
  
  // Company endpoints
  getCompanyDetails: async (companyName) => {
    console.log('Getting details for company:', companyName);
    const response = await fetch(`/api/company/search/${encodeURIComponent(companyName)}`);
    if (!response.ok) {
      throw new Error('Company details not found');
    }
    const data = await response.json();
    console.log('Company details:', data);
    // Return the first matching company
    return Array.isArray(data) && data.length > 0 ? data[0] : null;
  },
  
  getCompanyValuation: async (company) => {
    console.log('getCompanyValuation called with:', company);
    
    try {
      if (!company.type || ![COMPANY_TYPES.LISTED, COMPANY_TYPES.UNLISTED].includes(company.type)) {
        throw new Error('Invalid company type');
      }

      if (!company.id) {
        throw new Error('Company ID is required');
      }

      const endpoint = company.type === COMPANY_TYPES.LISTED
        ? `/api/company/listed/${encodeURIComponent(company.id)}`
        : `/api/company/unlisted/${encodeURIComponent(company.id)}`;
      
      console.log('Calling valuation endpoint:', endpoint);
      const response = await fetch(endpoint);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('API error response:', errorText);
        throw new Error(`Failed to get company valuation: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Raw API Response:', data);

      // Values are already in millions USD format, no need to format
      const formattedData = {
        ...data,
        estimatedValue: data.estimatedValue ? `$${data.estimatedValue}` : '$0',
        estimatedPortfolioValue: data.estimatedPortfolioValue ? `$${data.estimatedPortfolioValue}` : '$0'
      };

      console.log('Formatted API Response:', formattedData);
      return formattedData;
    } catch (error) {
      console.error('Error in getCompanyValuation:', error);
      throw error;
    }
  },
  
  getCompaniesList: async () => {
    const response = await fetch('/api/companies');
    if (!response.ok) {
      throw new Error('Failed to fetch companies list');
    }
    return response.json();
  },

  // Email endpoint
  sendEmail: async (formData) => {
    try {
      const requestBody = {
        senderName: "PricePatent",
        sender: "pricepatent@wisdomain.com",
        receiver: "pricepatent@wisdomain.com",
        BCCs: ["aliceyk@wisdomain.com"],
        subject: `[PricePatent] ${formData.subject}`,
        body: formData.message
      };
      
      const response = await fetch('/api/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      // Read response body once (can only be read once)
      const text = await response.text();
      
      if (!response.ok) {
        throw new Error(`Failed to send email: ${response.status} ${response.statusText}. ${text || ''}`);
      }

      // Check if there's any content before trying to parse JSON
      if (!text) {
        return { success: true }; // Return a default success object if no content
      }
      
      try {
        return JSON.parse(text);
      } catch (e) {
        return { success: true }; // Return success if not JSON but response was ok
      }
    } catch (error) {
      console.error('Error in sendEmail:', error);
      throw error;
    }
  }
};

export default apiService;